'use strict';

// cant use some es6 methods without full polyfill
const _ = require('underscore');

const ThumbnailTray = require('./ThumbnailTray');
const MediaContainer = require('./MediaContainer');

const DEFAULT_RATIO = 700 / 420;

class DealCarousel {
  constructor(payload) {
    this.data = payload.carousel;
    this.$el = $('#carousel');
    this.isLoaded = false;

    if (this.data.showControls) {
      this.$controlForward = this.$el.find('.carousel-controls .forward');
      this.$controlBack = this.$el.find('.carousel-controls .back');
    }

    if (this.data.hasMultipleImages) {
      this.thumbnailTray = new ThumbnailTray(this.data, this.$el);
    }

    const postSwapActions = {};
    if (this.data.hasTraits) {
      _.extend(postSwapActions, {
        triggerCarouselUpdate: () => this.triggerCarouselUpdate(),
      });
    }
    if (this.data.hasMultipleImages) {
      _.extend(postSwapActions, {
        updateThumbnail: nextMediaObj =>
          this.thumbnailTray.jumpToThumbnail(nextMediaObj.getId()),
      });
    }

    window.DealEventPipe.on('carouselLoaded', this.onLoad, this);
    const onLoadAction = "DealEventPipe.trigger('carouselLoaded')";
    this.mediaContainer = new MediaContainer(
      this.data,
      this.$el,
      onLoadAction,
      postSwapActions
    );

    if (this.data.hasTraits) {
      window.DealEventPipe.on('traitsUpdate', data =>
        this.handleTraitsUpdate(data)
      );
    }

    this.fixHeight();

    $(window).load(() =>
      window.Groupon.Utils.lazyLoadImages(this.$el.find('.sleepy-load'), {
        skip_invisible: true,
      })
    );

    return this;
  }

  handleTraitsUpdate(data) {
    if (this.isLoaded) {
      this.mediaContainer.handleMediaSwap('getIndexFromTraits', data, {
        triggerCarouselUpdate: undefined,
      });
    } else if (this.data.hasTraits) {
      this.traitsTriggeredDuringPreload = data;
    }
  }

  fixHeight() {
    let width = this.$el.width();
    if (this.data.hasMultipleImages && this.thumbnailTray.isVertical) {
      width = width - this.thumbnailTray.$thumbnailWrapper.outerWidth(true);
    }

    const height = width / (this.data.ratio || DEFAULT_RATIO);
    this.mediaContainer.fixHeight(height, width);
    if (this.data.hasMultipleImages) {
      this.thumbnailTray.fixHeight(height);
    }
  }

  onLoad() {
    if (this.isLoaded) {
      return;
    }
    this.isLoaded = true;
    this.fixHeight();
    this.mediaContainer.onLoad();

    if (this.traitsTriggeredDuringPreload) {
      this.handleTraitsUpdate(this.traitsTriggeredDuringPreload);
      this.traitsTriggeredDuringPreload = undefined;
    } else {
      if (this.data.imageZoom) {
        this.mediaContainer.setUpZoom(this.mediaContainer.currentMedia);
      }
      this.mediaContainer.preloadMedia();
    }

    if (this.data.showControls) {
      this.$controlForward.click(e => {
        this.mediaContainer.handleMediaSwap('incrementIndex', { e });
        if (this.mediaContainer.autoSlideShow) {
          this.mediaContainer.autoSlideShow.disable();
        }
      });
      this.$controlBack.click(e => {
        this.mediaContainer.handleMediaSwap('decrementIndex', { e });
        if (this.mediaContainer.autoSlideShow) {
          this.mediaContainer.autoSlideShow.disable();
        }
      });
    }

    if (this.data.hasMultipleImages) {
      this.thumbnailTray.onLoad(this.mediaContainer.getActiveId());

      this.thumbnailTray.$thumbnails.on(
        this.thumbnailTray.getChangeEventType(),
        e => {
          this.mediaContainer.handleMediaSwap(
            'getIndexByDataId',
            { e, dataId: e.currentTarget.dataset.id },
            {
              updateThumbnail: (nextMediaObj, data) =>
                this.thumbnailTray.adjustThumbnail(nextMediaObj.getId(), data),
            }
          );
          if (this.thumbnailTray.getChangeEventType() === 'click') {
            if (this.mediaContainer.autoSlideShow) {
              this.mediaContainer.autoSlideShow.disable();
            }
          }
        }
      );
    }

    $(window).resize(() => this.fixHeight());
  }

  triggerCarouselUpdate() {
    window.DealEventPipe.trigger(
      'carouselUpdate',
      this.mediaContainer.getTraitsByIndex()
    );
  }
}

module.exports = DealCarousel;
